export function formatNumberWithCommas(x = 0, fractionDigits = 2) {
  return Number.parseFloat(x.toString())
    .toFixed(fractionDigits)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
